export const ACCOUNT_TYPES = [
	{ value: "asset", label: "Asset" },
	{ value: "liability", label: "Liability" },
	{ value: "equity", label: "Equity" },
	{ value: "income", label: "Income" },
	{ value: "expense", label: "Expense" },
];

export const AMOUNT_KEYS = [
	{ value: "amount", label: "amount — principal (rent / payout / expense)" },
	{ value: "fee_paid", label: "fee_paid — fee / charge component" },
	{ value: "gross", label: "gross — amount + fee_paid" },
];

export const LINE_SIDES = [
	{ value: "debit", label: "Debit" },
	{ value: "credit", label: "Credit" },
];

export const STARTER_ACCOUNTS = [
	{ code: "1000", name: "Cash on hand", account_type: "asset" },
	{ code: "1010", name: "MTN MoMo wallet", account_type: "asset" },
	{ code: "1020", name: "Airtel Money wallet", account_type: "asset" },
	{ code: "1030", name: "Bank clearing", account_type: "asset" },
	{ code: "1040", name: "Airtel Merchant clearing", account_type: "asset" },
	{ code: "2000", name: "Landlord payable", account_type: "liability" },
	{ code: "2100", name: "Security deposits held", account_type: "liability" },
	{ code: "2200", name: "Broker commission payable", account_type: "liability" },
	{ code: "4000", name: "Rent income", account_type: "income" },
	{ code: "4100", name: "Service fee income", account_type: "income" },
	{ code: "5000", name: "Property expenses", account_type: "expense" },
	{ code: "5100", name: "Broker commission expense", account_type: "expense" },
];

export const PAYMENT_METHOD_EXAMPLES = [
	{ method: "Cash", account: "1000 Cash on hand" },
	{ method: "MTN", account: "1010 MTN MoMo wallet" },
	{ method: "Airtel", account: "1020 Airtel Money wallet" },
	{ method: "Bank", account: "1030 Bank clearing" },
	{ method: "Airtel Merchant", account: "1040 Airtel Merchant clearing" },
];

/** Suggested posting policies — create one template per org for each event you use. */
export const POSTING_POLICY_EXAMPLES = [
	{
		event_type: "tenant_rent_collected",
		label: "Tenant rent collected",
		when: "Successful rent payment",
		lines: [
			{ side: "debit", code: "1000", amount_key: "gross", uses_payment_method: true },
			{ side: "credit", code: "4000", amount_key: "amount", uses_payment_method: false },
			{ side: "credit", code: "4100", amount_key: "fee_paid", uses_payment_method: false },
		],
	},
	{
		event_type: "tenant_security_deposit_collected",
		label: "Security deposit collected",
		when: "Payment marked as security deposit",
		lines: [
			{ side: "debit", code: "1000", amount_key: "amount", uses_payment_method: true },
			{ side: "credit", code: "2100", amount_key: "amount", uses_payment_method: false },
		],
	},
	{
		event_type: "tenant_security_deposit_refunded",
		label: "Security deposit refunded",
		when: "Security deposit marked refunded",
		lines: [
			{ side: "debit", code: "2100", amount_key: "amount", uses_payment_method: false },
			{ side: "credit", code: "1000", amount_key: "amount", uses_payment_method: true },
		],
	},
	{
		event_type: "tenant_rent_voided",
		label: "Tenant rent voided",
		when: "Payment voided (reverses collect JE)",
		lines: [
			{ side: "debit", code: "4000", amount_key: "amount", uses_payment_method: false },
			{ side: "credit", code: "1000", amount_key: "gross", uses_payment_method: true },
		],
	},
	{
		event_type: "landlord_payout_made",
		label: "Landlord payout made",
		when: "Landlord payout succeeds",
		lines: [
			{ side: "debit", code: "2000", amount_key: "amount", uses_payment_method: false },
			{ side: "credit", code: "1000", amount_key: "amount", uses_payment_method: true },
		],
	},
	{
		event_type: "expense_recorded",
		label: "Expense recorded",
		when: "Landlord expense posted",
		lines: [
			{ side: "debit", code: "5000", amount_key: "amount", uses_payment_method: false },
			{ side: "credit", code: "1000", amount_key: "amount", uses_payment_method: true },
		],
	},
	{
		event_type: "expense_voided",
		label: "Expense voided",
		when: "Expense soft-deleted / voided",
		lines: [
			{ side: "debit", code: "1000", amount_key: "amount", uses_payment_method: true },
			{ side: "credit", code: "5000", amount_key: "amount", uses_payment_method: false },
		],
	},
	{
		event_type: "broker_commission_accrued",
		label: "Broker commission accrued",
		when: "Broker commission created",
		lines: [
			{ side: "debit", code: "5100", amount_key: "amount", uses_payment_method: false },
			{ side: "credit", code: "2200", amount_key: "amount", uses_payment_method: false },
		],
	},
	{
		event_type: "broker_commission_paid",
		label: "Broker commission paid",
		when: "Broker commission marked paid",
		lines: [
			{ side: "debit", code: "2200", amount_key: "amount", uses_payment_method: false },
			{ side: "credit", code: "1000", amount_key: "amount", uses_payment_method: true },
		],
	},
];

/** @deprecated use POSTING_POLICY_EXAMPLES[0].lines */
export const TENANT_RENT_COLLECTED_EXAMPLE = POSTING_POLICY_EXAMPLES[0].lines;
